import { Action, Reducer, ReducersMapObject } from "redux";

// -- Need to support the "unknown" type because the platform sometimes uses "as any" when combining reducers.
function getExtensionPropsFromCombinedReducer<A extends Action, S = unknown>(
    reducer: Reducer<S, A>,
): ReducersMapObject<S, A>;
// -----------------------------------------------------------------------------------------------------------

function getExtensionPropsFromCombinedReducer<A extends Action, S extends { [key: string]: any }>(
    combinedReducer: Reducer<S, A>,
) {
    const result = {} as ReducersMapObject<S, A>;

    // Call the combined reducer with dummy values to get the default state.
    const baseState = combinedReducer({} as S, { type: ":NONE:" } as A);

    // Create a dictionary of empty reducers based on the state properties.
    Object.keys(baseState).forEach((key: keyof S) => {
        result[key] = state => state || ({} as S[keyof S]);
    });

    return result;
}

export default getExtensionPropsFromCombinedReducer;
